import { useEffect } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Diagram from './pages/Diagram/Diagram';
import Page404 from './pages//Page404/Page404';

import { selectThemeMode } from './redux/diagram/diagram.selectors';

import { useTranslation } from 'react-i18next';

const App = () => {
    const location = useLocation();
    const themeMode = useSelector(selectThemeMode);

    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);

    return (
        <div className={`App ${themeMode ? 'light-mode' : 'dark-mode'}`}>
            <Switch location={location} key={location.pathname}>

                {/* Quick Share Page */}
                <Route
                    exact
                    path="/quick-share"
                    render={() => <Diagram isQuickShare={true} />}
                />

                {/* New Project Page */}
                <Route
                    exact
                    path="/new"
                    render={() => <Diagram isNew={true} />}
                />

                {/* Playground Page */}
                <Route
                    exact
                    path="/"
                    render={() => <Diagram />}
                />

                {/* Diagram Page */}
                {/* <Route
                    exact
                    path="/templates/:diagramId"
                    render={() => <Diagram />}
                /> */}

                {/* 404 Page Redirect */}
                {/* <Route
                    exact
                    path="/not-found"
                    component={Page404}
                /> */}

                {/* Redirect to Playground Page*/}
                <Route path="*">
                    <Redirect to="/" />
                </Route>

            </Switch>
        </div>
    );
};

export default App;
